// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"361":"fec06a7b0b94bf48","413":"59ad24cc7f1bf3fd","538":"dc44f207236aa7ec"}[chunkId] + ".js";
};